import { client, DEFAULT_HEADERS } from "./defaultClient";

export const getGeneratedQCandidate = async () => {
    const response = await client.getGenQcandidate({
        mode: "cors",
        headers: DEFAULT_HEADERS,
    });
    return response;
};
